import { forwardRef } from 'react';
import { useFela } from 'react-fela';

import { ButtonHTMLType } from '../Button';
import { Icon, type IconProps } from '../Icon';
import { defaultStyle, ghostTypeStyle, primaryTypeStyle } from './IconButton.rules';
import { IconButtonType } from './types';

const typeStyleMap = {
    [IconButtonType.DEFAULT]: [defaultStyle],
    [IconButtonType.PRIMARY]: [defaultStyle, primaryTypeStyle],
    [IconButtonType.GHOST]: [ghostTypeStyle],
};

export interface IconButtonProps extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'type'> {
    icon: IconProps['type'] | IconProps;
    type?: `${IconButtonType}`;
    htmlType?: `${ButtonHTMLType}`;
    customStyle?: typeof defaultStyle;
    children?: React.ReactNode;
}

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
    ({ type = IconButtonType.DEFAULT, icon, htmlType = ButtonHTMLType.BUTTON, customStyle, children = null, ...props }, ref) => {
        const { css } = useFela();

        return (
            <button
                {...props}
                ref={ref}
                className={`IconButton IconButton-${type} ${css(...typeStyleMap[type], customStyle)}`}
                type={htmlType}
            >
                {typeof icon === 'string' ? <Icon type={icon} /> : <Icon {...icon} />}
                {children}
            </button>
        );
    },
);
